import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import useWindowSize from "./PageWidth";
import AccountDetails from "./ProfileTabs/AccountDetails";
import LoginDetails from "./ProfileTabs/LoginDetails";
import BankDetails from "./ProfileTabs/BankDetails";
import { useLocation, useNavigate } from "react-router-dom";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function ProfileTabs() {
  const [value, setValue] = React.useState(0);
  const size = useWindowSize();
  const navigate = useNavigate();
  const location = useLocation();

  const currentLocation = location.search.slice(1);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate("/profile?" + newValue);
  };

  return (
    <Box sx={{ width: "100%", position: "relative" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={parseInt(currentLocation) || value}
          onChange={handleChange}
          variant={size.width > 768 ? "fullWidth" : "scrollable"}
          textColor="inherit"
        >
          <Tab label="Account Details" {...a11yProps(0)} />
          <Tab label="Change Password" {...a11yProps(1)} />
          <Tab label="Bank Details" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={parseInt(currentLocation) || value} index={0}>
        <AccountDetails />
      </CustomTabPanel>
      <CustomTabPanel value={parseInt(currentLocation) || value} index={1}>
        <LoginDetails />
      </CustomTabPanel>
      <CustomTabPanel value={parseInt(currentLocation) || value} index={2}>
        <BankDetails />
      </CustomTabPanel>
    </Box>
  );
}
